module.exports = __webpack_public_path__ + "salesforce-1-eeb7ddfbb67b72d801a9ab69704db0ab.webp";